import React from 'react';
import { FadeUp } from './FadeUp';
import { GrowthVisualization } from './illustrations/GrowthVisualization';
export function Benefits() {
  const benefits = [{
    icon: '🏆',
    title: 'Instant Authority',
    desc: 'The moment someone hits your profile, the first impression says: "This brand is legit."'
  }, {
    icon: '💰',
    title: 'Higher Conversion Rate',
    desc: 'An active-looking account converts better. Trust shortens the buying decision.'
  }, {
    icon: '📡',
    title: 'Expanded Organic Reach',
    desc: "The algorithm starts showing your content to people who haven't found you yet."
  }, {
    icon: '✨',
    title: 'Elevated Brand Image',
    desc: 'Your profile stops looking like a "small project" and starts positioning you as an industry name.'
  }, {
    icon: '⏳',
    title: 'Save Time & Energy',
    desc: "You don't have to rely solely on slow organic strategies. Results you can actually see."
  }, {
    icon: '🎯',
    title: 'Everything You Create Works Harder',
    desc: 'Your content deserves to be seen. We make sure it reaches the people it should.'
  }];
  return <section id="beneficios" className="bg-bg-secondary border-y border-cyan/10 relative z-10 py-[72px] md:py-[100px] overflow-hidden" data-id="element-36">
      {/* Background Growth Visualization */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] pointer-events-none -z-10 opacity-50" data-id="element-37">
        <GrowthVisualization data-id="element-38" />
      </div>

      <div className="max-w-[900px] mx-auto px-6 relative z-10" data-id="element-39">
        <FadeUp className="text-center mb-14" data-id="element-40">
          <span className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-blue-electric mb-4" data-id="element-41">
            What you gain
          </span>
          <h2 className="text-[clamp(26px,4vw,36px)] font-heading font-bold uppercase leading-[1.2] tracking-[0.05em] mb-6" data-id="element-42">
            Real results for your brand
          </h2>
          <p className="text-white-dim text-base max-w-[560px] leading-[1.7] mx-auto" data-id="element-43">
            More than metrics — a profile that radiates authority, earns trust,
            and converts.
          </p>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-44">
          {benefits.map((benefit, i) => <FadeUp key={i} delay={i * 0.08} data-id="element-45">
              <div className="animated-border bg-bg-card rounded-sm p-7 flex items-start gap-[18px] transition-all duration-300 ease-in hover:-translate-y-0.5 h-full" data-id="element-46">
                <div className="w-11 h-11 bg-gradient-to-br from-cyan/15 to-cyan/5 border border-cyan/10 rounded-sm flex items-center justify-center text-[20px] shrink-0 relative z-10" data-id="element-47">
                  {benefit.icon}
                </div>
                <div className="relative z-10" data-id="element-48">
                  <h4 className="text-[14px] font-heading font-semibold uppercase tracking-[0.05em] mb-2" data-id="element-49">
                    {benefit.title}
                  </h4>
                  <p className="text-[13px] text-white-dim leading-[1.6]" data-id="element-50">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </FadeUp>)}
        </div>
      </div>
    </section>;
}